import { AxiosRequestConfig, AxiosResponse } from "axios";
import apiGuard from "../../../context-controller-mod/context-serv/global-provider/api-shell/api-gaurd";

const ApiGet = <T = unknown>(
  url: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<T>> => {
  return apiGuard.get<T>(url, {
    ...config,
    paramsSerializer: (params) =>
      new URLSearchParams(params as any) //NOSONAR
        .toString()
        .replaceAll("+", "%20"), 
  });
};

export default ApiGet;